module.exports = __webpack_public_path__ + "static/media/white-favorite.3c04cbd1.svg";